import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Lock, KeyRound } from "lucide-react";
import { useAuth, formatApiError } from "@/lib/auth";

export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords don't match"); return; }
    setBusy(true);
    try {
      await resetPassword(token, password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <main className="max-w-md mx-auto px-5 pt-24 pb-16">
      <div className="text-center mb-8">
        <KeyRound className="w-10 h-10 text-emerald-500 mx-auto" />
        <h1 className="fl-display text-3xl font-extrabold mt-3">SET A NEW PASSWORD</h1>
      </div>

      {!token ? (
        <div className="fl-card p-6 text-center text-slate-400">Missing reset token. <Link to="/forgot-password" className="text-emerald-500 hover:underline">Request a new link.</Link></div>
      ) : (
        <form onSubmit={submit} className="fl-card p-6 space-y-4">
          <label className="block">
            <span className="fl-mono text-[10px] tracking-[0.25em] uppercase text-slate-500">New password (min 8 chars)</span>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
              <input type="password" required minLength={8} className="fl-input pl-9" value={password} onChange={e => setPassword(e.target.value)} data-testid="reset-password-input" />
            </div>
          </label>
          <label className="block">
            <span className="fl-mono text-[10px] tracking-[0.25em] uppercase text-slate-500">Confirm new password</span>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
              <input type="password" required minLength={8} className="fl-input pl-9" value={confirm} onChange={e => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
            </div>
          </label>
          {error && <div className="text-sm text-red-400" data-testid="reset-error">{error}</div>}
          <button type="submit" disabled={busy} className="fl-btn w-full" data-testid="reset-submit">{busy ? "Saving…" : "Set new password"}</button>
        </form>
      )}
    </main>
  );
}
